import redirectTo from 'redux/utils/redirectTo';
import { getRouteByResponseStatus } from 'utils/functions/routesHelper';

function* redirectToErrorPage(responseStatus) {
    const route = getRouteByResponseStatus(responseStatus);
    yield redirectTo(route);
}

export default redirectToErrorPage;
